module.exports = __webpack_public_path__ + "567915a92420d5c1b3e360af849c1b03.svg";